import { createAction, props } from '@ngrx/store';
import { Inventory } from './inventory.models';

export const init = createAction('[Inventory Page] Init');

export const loadInventorySuccess = createAction(
    '[Inventory/API] Load Inventory Success',
    props<{ items: Inventory[] }>()
);

export const loadInventoryFailure = createAction('[Inventory/API] Load Inventory Failure', props<{ error: any }>());
